// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3igaj","sendOtp":"AuthorizeToLogin_sendOtp__2rPP2"};